module.exports = __webpack_public_path__ + "static/media/img-heritage-area7-miikeTanko03.a3fc983e.jpg";